import { render, staticRenderFns } from "./Phase.vue?vue&type=template&id=6910bf34&scoped=true&"
import script from "./Phase.vue?vue&type=script&lang=js&"
export * from "./Phase.vue?vue&type=script&lang=js&"
import style0 from "./Phase.vue?vue&type=style&index=0&id=6910bf34&lang=scss&scoped=true&"
import style1 from "./Phase.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6910bf34",
  null
  
)

export default component.exports